import episodeRouter from "@/routes/episodeRouter"
import { i18n } from "@/plugins/i18n"

export default [
  {
    path: "podcasts",
    component: () => import("@/views/Podcasts/Podcasts.vue"),
    children: [
      {
        path: "",
        name: "podcasts",
        component: () => import("@/views/Podcasts/PodcastList.vue"),
        meta: {
          pageTitle: i18n.t("podcasts.list_title"),
          rule: "owner",
        },
      },
      {
        path: "create",
        component: () => import("@/views/Podcasts/PodcastAdd.vue"),
        name: "podcast.create",
        props: true,
        meta: {
          pageTitle: i18n.t("podcasts.add_title"),
          parent: "podcasts",
          rule: "owner",
        },
      },
      {
        path: ":podcastKey",
        component: () => import("@/views/Podcasts/Podcast.vue"),
        name: "podcast",
        props: true,
        meta: {
          pageTitle: "Podcast info",
          parent: "podcasts",
          rule: "owner",
        },
        children: [
          {
            name: "podcast.distribute",
            path: "distribute",
            component: () => import("@/views/Podcasts/PodcastDistribute.vue"),
            meta: {
              pageTitle: i18n.t("podcasts.distribute_title"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          {
            name: "podcast.settings",
            path: "settings",
            component: () => import("@/views/Podcasts/PodcastSettings.vue"),
            meta: {
              pageTitle: i18n.t("podcasts.settings_title"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          {
            name: "podcast.ads_settings",
            path: "ad-settings",
            component: () => import("@/views/Podcasts/AdPlacement.vue"),
            meta: {
              pageTitle: i18n.t("podcasts.ads_settings_title"),
              parent: "podcasts",
              rule: "owner",
            },
          },
          ...episodeRouter,
        ],
      },
    ],
  },
]
